import { Container, Stack } from '@mui/material'
import { useEffect } from 'react'
import { Body } from 'src/components/MUIBased/Blocks/Body'
import { ContainerTitle } from 'src/components/MUIBased/Blocks/ContainerTitle'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { useAmpli } from 'src/hooks/useAmpli'
import { LoadingScreen } from 'src/pages/MUIBased/Home'
import { NoLabResults } from 'src/pages/MUIBased/LabResults/NoLabResults'
import { useGetLabResults } from './hooks/useGetLabResults'
import { LabResultItem } from './LabResultItem'
import { searchResultsToRows } from './utils/searchResultsToRows'

export const LabResultsContent = () => {
    const { labResultsViewed } = useAmpli()
    const { labResults: loaderResults, isLoading } = useGetLabResults()

    const labResults = searchResultsToRows(loaderResults)

    useEffect(() => {
        if (!isLoading) {
            labResultsViewed()
        }
    }, [labResultsViewed, isLoading])

    if (isLoading) {
        return <LoadingScreen isLoading />
    }

    return (
        <Body>
            <StandardPageHeader />
            <NavBarHeading href="/your-care">Lab Results</NavBarHeading>

            <Container>
                <ContainerTitle
                    title="Your Lab Results"
                    description="View and track your lab results here. Your healthcare provider will add lab results as they become available."
                />

                {labResults && labResults.length > 0 ? (
                    <Stack>
                        {labResults.map((result, index) => (
                            <LabResultItem
                                key={index}
                                id={result.id}
                                orderDate={result.orderDate}
                                test={result.test}
                                requester={result.requester}
                                labPerformer={result.labPerformer}
                            />
                        ))}
                    </Stack>
                ) : (
                    <NoLabResults />
                )}
            </Container>
        </Body>
    )
}
